import twLocale from 'element-ui/lib/locale/lang/zh-TW'
const zh_tw = {
    sysCode:{
        SYSTEM_ERROR:"系統出錯了",
        PARAMS_ERROR:"參數錯誤",
        ASSETS_UPDATE_ERROR: "資產操作失敗",
        PARENT_ERROR:"邀請地址無效",
        PARENT_BOUND:"已經綁定過邀請地址",
        PARENT_CANNOT_SELF:"不能綁定自己",
        PARENT_CHILD:"綁定位址是下級位址",
        TAKE_WEEK:"一週只能領取一次",
        TAKE_OUT_MIN:"小於最小領取數量",
        TAKE_ASSETS_EMPTY:"沒有可領取資產",
        TAKE_NOT_ENOUGH:"可領取數不足",
        TAKE_ERROR:"領取收益失敗",
        REDEEM_OUT_MIN:"小於最小贖回數量",
        REDEEM_ASSETS_EMPTY:"沒有可贖回資產",
        REDEEM_NOT_ENOUGH:"可贖回數量不足",
        REDEEM_ERROR:"贖回失敗",
        PWD_FORMAT_ERROR:"密碼格式不正確",
        NOT_LEADER:"不是商戶，無權操作",
    },
    common:{
        lostTitle:"溫馨提示",
        lostContent:"目前的網路環境存取權限受到限制，我們無法為中國大陸地區提供服務，請您遵守所在國家和地區相關規定存取我們的服務。",
        connect:"連結",
        walletMsgPro:"請使用 Binance Smart Chain Mainnet 登入",
        walletMsgTest:"請使用 Binance Smart Chain Testnet 登入",
        notice:"公告",
        paramError:"參數錯誤",
        walletBalance:"錢包餘額",
        walletUsdtOut:"錢包USDT不足",
        walletTokenOut:"錢包RWAS不足",
        usdtBalanceOut:"USDT餘額不足",
        tokenBalanceOut:"RWAS餘額不足",
        lpBalanceOut:"LP餘額不足",
        balance:"餘額",
        approve:"授權",
        sign:"交易簽名",
        approveFail:"授權失敗",
        confirmByWallet:"請在錢包中完成確認",
        language:"語言設定",
        musicVolumnSet:"背景音樂",
        soundVolumnSet:"遊戲音效",
        loading:"正在拼命載入中...",
        confirming:"確認中...",
        messageTitle:"提示訊息",
        tips:"提示",
        confirm:"確定",
        cancel:"取消",
        success:"成功",
        fail:"失敗",
        takeRecord:"領取記錄",
        noData:"暫無記錄",
        noLogin:"未登入",
        take:"領取",
        takeSuccess:"領取成功",
        takeFail:"領取失敗",
        release:"退出",
        releaseSuccess:"退出成功",
        releaseFail:"退出失敗",
        notReady:"（敬請期待）",
        notStart:"敬請期待",
        copySuccess:"複製成功",
        max:"最大",
        min:"最少 ",
        time:"時間",
        amount:"數量",
        status:"狀態",
        type:"類型",
        address:"地址",
        level:"等級",
        filter:"篩選",
        all:"全部",
        setLoginPwd:"設定後台登入密碼",
        inputLoginPwd:"請填寫後台登入密碼",
        loginPwdRule:"6~20位任意數字、字母組合",
        submit:"確認",
        submitPending:"確認中",
        loginPwdRuleError:"密碼格式不正確",
        hash:"交易Hash",
        more:"點擊看更多",
        nomore:"沒有更多數據了",
        enterQuantity:"輸入數量",
        remove:"移除",
    },
    menu:{
        home:"質押",
        swap:"Swap",
        exchange:"兌換"
    },
    main:{
        banner1:"一鍵質押",
        banner2:"領取",
        banner3:"獎勵",
        myJoin:"我的參與",
        selfAmt:"質押數量",
        underAmt:"傘下質押",
        released:"已釋放",
        locked:"待釋放",
        inviteNum:"有效邀請 / 总邀请",
        joinForCoin:"質押賺幣",
        poolInfo:"礦池資訊",
        profitCoin:"收益幣種",
        totalProfit:"用戶累計收益",
        totalReward:"累計收益",
        joinStep:"參與流程",
        step1:"01.連結錢包或建立新的Web3錢包",
        step2:"02.填寫邀請碼",
        step3:"03.質押 USDT",
        step4:"04.領取收益",
        rule:"獎勵規則",
        parentAddress:"邀请码",
        parentValid:"邀请码无效",
        parentTitle:"填寫邀請碼，共享收益",
        leaderAccount:"商家角色不能參與",
        invalidAccount:"帳號未激活，請先綁定邀請碼啟動",
    },
    my:{
        inviteCode:"我的邀請碼",
        level:"等級",
        notice:"邀請收益資料將在每日更新",
        waitTake:"待領取收益",
        takeProfit:"領取收益",
        profitInfo:"收益資訊",
        daoRank:"節點排行",
        address:"用戶名",
        self:"自己",
        profitEmpty:"暫無可領取收益",
        take:"領取",
        canTakeAmt:"可領取數量",
        costTakeFee:"本次領取需扣除手續費：",
        tips:"提示：每週只能領取一次",
    },
    myOrder:{
        orderList:"投資明細",
        valid:"挖礦中",
        invalid:"已失效",
        orderDetail:"訂單詳情",
        totalAmt:"總金額",
        joinDate:"質押时间",
        profitAt:"起息日",
        interestCycle:"發息週期",
        redeemDate:"贖回日期",
        anyTime:"隨時贖回",
        status:"訂單狀態",
        amount:"數量",
        apy:"參考年化",
        released:"已釋放收益",
        locked:"待釋放收益",
        redeemTime:"贖回時間",
        redeemFee:"贖回手續費",
        estimatedTime:"預計到帳時間",
        redeemResult:"贖回結果",
        redeem:"贖回",
        redeeming:"贖回中",
        redeemed:"已贖回",
        costRedeemFee:"本次贖回需扣除手續費：",
        pending:"處理中",
        confirm:"已完成",
        cancel:"已取消",
    },
    myProfit:{
        nav1:"收益紀錄",
        nav2:"領取紀錄",
        redeem:"贖回",
        take:"領取",
        takeAmount:"數量",
        takeFee:"手續費",
        takeTime:"時間",
        estimatedTime:"預計到帳時間",
        takeDetail:"領取詳情",
        mining:"挖礦收益",
        invite:"推廣收益",
        dao:"節點收益",
        remain:"沉澱",
    },
    pledge:{
        time:"期限",
        anyTime1:"隨存隨取",
        yearRate:"預估年化報酬率",
        myPledge:"目前質押數量",
        pledge:"質押",
        selectCoin:"選擇質押幣種",
        dayProfit:"預計每日獲得",
        redeemWay:"贖回時間",
        anyTime2:"隨時贖回",
        inputError:"請輸入正確的質押數量",
        minPledge:"最少質押數量 ",
        fail:"質押失敗",
        cannotJoin:"您不能參與",
        forRwas:"兌 RWAS",
    },
    result:{
        recharge:"質押成功",
        redeem:"贖回成功",
        take:"領取成功",
        goMyInfo:"查看資產",
    },
    exchange:{
        oneClick:"一鍵兌換",
        oldRwasAddress:"舊 RWAS 合約",
        newRwasAddress:"新 RWAS 合約",
        oldRwasBalance:"舊 RWAS 餘額",
        newRwasBalance:"新 RWAS 餘額",
        confirm:"確認兌換",
        rwasApproveFail:"RWAS授權失敗",
        exchangeSuccess:"兌換成功",
        exchangeFail:"兌換失敗",
    },
    liquidity:{
        deposit:"質押",
        withdraw:"贖回",
        add:"添加流動性",
        withdrawable:"可贖回LP",
        myDeposit:"我的質押",
        depositAmount:"質押數量",
        claimableReward:"待領取收益",
        claim:"領取收益",
        pool:"流動池資訊",
        totalValue:"總價值",
        price:"價格",
        contracts:"合約資訊",
        lpAddress:"流動池合約",
        rwasAddress:"RWAS合約",
        inputDepositAmount:"請輸入質押數",
        lpBalanceOut:"錢包LP餘額不足",
        lpApproveFail:"LP授權失敗",
        depositSuccess:"質押成功",
        depositFail:"質押失敗",
        inputRedeemAmount:"請輸入贖回數量",
        redeemableBalanceOut:"可贖回數量不足",
        redeem:"取回",
        redeemed:"已取回",
        redeemSuccess:"取回成功",
        redeemFail:"取回失敗",
        inputRwasAmout:"請輸入RWAS數量",
        rwasBalanceOut:"錢包RWAS餘額不足",
        rwasApproveFail:"RWAS授權失敗",
        inputUsdtAmout:"請輸入USDT數",
        usdtBalanceOut:"錢包USDT餘額不足",
        usdtApproveFail:"USDT授權失敗",
        addSuccess:"增加流動性成功",
        addFail:"增加流動性失敗",
        rewardEmpty:"暫無可領取收益",
        claimSuccess:"領取收益成功",
        claimFail:"領取收益失敗",

        totalLp:"LP总量",
        myLp:"我的LP",
        myLpRate:"我的LP占比",
        removeLpTitle:"移除流動性",
        removeLpTips:"提示：移除LP會按照當前匯率將您的LP轉換回基礎代幣，與您在池中的支出成比例。應計費用包含在您收到的金額中。",
        removeAmount:"移除數量",
        removeSuccess:"移除流動性成功",
        removeFail:"移除流動性失敗",
    },
    swap:{
        title:"Swap",
        swapSuccess:"交易成功",
        swapFail:"交易失敗",
        buy:"買入",
        sell:"賣出",
        liquidity:"流動性",
        myOrders:"我的Swap訂單"
    },
  ...twLocale
}
export default zh_tw